import { gql } from '@apollo/client'

import { DICTIONARY_WORD_FRAGMENT } from '../fragments'

const DICTIONARY_WORDS_QUERY = gql`
  query dictionaryWords(
    $filters: DictionaryWordFiltersInput
    $page: Int
    $pageSize: Int
  ) {
    dictionaryWords(filters: $filters, page: $page, pageSize: $pageSize) {
      results {
        ...DictionaryWordFragment
      }
      total
    }
  }
  ${DICTIONARY_WORD_FRAGMENT}
`

export default DICTIONARY_WORDS_QUERY
